import { Directive, ElementRef, TemplateRef, ViewContainerRef, Input, OnDestroy } from '@angular/core';
import { PermissionsService } from 'src/app/services/permissions.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { PermissionsInfo } from 'src/app/components/permissions-info';

@Directive({
    selector: '[hasPermission]',
    standalone: false
})
export class HasPermissionDirective implements OnDestroy {    

    @Input()
    set hasPermission(info: PermissionsInfo) {        
        if(this.permissionsSubscription){
            return;
        }
        
        this.permissionsSubscription = this.permissionsService.getEntityPermissions$(info.areaPermissionKey, info.entityPermissionKey).subscribe(x => {
            if (x) {

                const canDisplayComponent = x.canRead === true;               

                if (canDisplayComponent) {
                    if (this.viewContainer.length === 0) {
                        this.viewContainer.createEmbeddedView(this.templateRef);
                    }
                }
                else if (this.viewContainer.length > 0) {
                    this.viewContainer.clear();
                }
            }
        });
    }

    private permissionsSubscription: Subscription;

    constructor(
        private element: ElementRef,
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private permissionsService: PermissionsService
    ) {        
    }

    ngOnDestroy(): void {
        if(this.permissionsSubscription){
            this.permissionsSubscription.unsubscribe();
        }
    }
}
